import React, { Component } from "react";
import { SubMenuLink } from "./SubMenuLink";
import { DashboardList } from "../../Common/Icons";

export default class DashboardsListLink extends Component {
  render() {
    return (
      <SubMenuLink
        pathname="/dashboards"
        title="dashboardsModels"
        // icon="Dashboards List"
      >
        <DashboardList className={"light-sub-menu-icon"} />
      </SubMenuLink>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/DashboardsListLink.js